<div class="dialog-content-wrapper with-loading-overlay" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <ng-container *ngIf="isSaving || isLoadingAvvPdf">
        <div class="loading-overlay" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="12px">
            <mat-spinner [diameter]="48"></mat-spinner>
            <span>{{ 'workflows.screens.signAvv.preparingFile' | translate }}</span>
        </div>
    </ng-container>
    <mat-toolbar matDialogTitle class="mat-accent m-0" cdkDragHandle>
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{ 'workflows.screens.signAvv.dialogTitle' | translate }}</span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content fusePerfectScrollbar>

        <h2>{{ 'workflows.screens.signAvv.whyTitle' | translate }}</h2>

        <p>
            {{ 'workflows.screens.signAvv.introP1' | translate }}
        </p>

        <p>
            {{ 'workflows.screens.signAvv.introP2' | translate }}
        </p>

        <mat-divider class="my-12"/>

        <em>{{ 'workflows.screens.signAvv.legalConsent' | translate }}</em>

        <mat-divider class="my-12"/>

        <form-widget-avv [parentFormGroup]="formGroup"
                         (loadingChange)="isLoadingAvvPdf = $event"></form-widget-avv>
    </div>

    <div mat-dialog-actions class="m-0 p-8 p-sm-16" fxLayout="row" fxLayoutAlign="space-between center">

        <ng-template #saving>
            <mat-icon>save</mat-icon>
            <span>{{ 'common.saving' | translate }}</span>
            <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
        </ng-template>

        <ng-template #notSaving>
            <mat-icon>save</mat-icon>
            <span>{{ 'workflows.screens.signAvv.confirmButton' | translate }}</span>
        </ng-template>

        <button data-test="B-Jetzt nicht..." type="button" mat-flat-button (click)="onClickClose()"
                [disabled]="isSaving">
            {{ 'workflows.screens.signAvv.notNow' | translate }}
        </button>

        <button data-test="B-AVV bestätigen" type="button" mat-flat-button color="accent"
                [disabled]="isSaving || isLoadingAvvPdf"
                (click)="onClickSaveAndClose()">
            <ng-container *ngIf="isSaving; then saving else notSaving"></ng-container>
        </button>

    </div>
</div>
